var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{staticStyle:{"background-color":"#212121"}},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1),_c('gm-snackbar'),_c('gm-loader'),_c('gm-cookies')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }